"use client";

import { useEffect } from "react";
import { apiFetch } from "@/lib/api";
import { getSessionToken } from "@/lib/session";

/**
 * Soft device sighting for correlation (not VPN unmask).
 */
export function SecuritySighting() {
  useEffect(() => {
    if (typeof window === "undefined") return;
    const token = getSessionToken();
    const body = {
      path: window.location.pathname,
      language: navigator.language,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      platform: navigator.platform,
      screen: `${screen.width}x${screen.height}`,
    };
    void apiFetch("/api/security/sighting", {
      method: "POST",
      headers: token
        ? {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          }
        : { "Content-Type": "application/json" },
      body: JSON.stringify(body),
      timeoutMs: 5000,
    }).catch(() => {
      /* non-fatal */
    });
  }, []);

  return null;
}
